import MatchEvent from '../interfaces/matchEvent';
import { MatchEventType } from '../enums/matchEventType';

export default function (matchEvents: Array<MatchEvent>): boolean {
  let penaltiesShootoutStarted = false;
  if (matchEvents) {
    matchEvents.forEach((matchEvent) => {
      if (matchEvent.matchEventTypeId === MatchEventType.PENALTIES) {
        penaltiesShootoutStarted = true;
      }
    });
  }
  return penaltiesShootoutStarted;
}
